import React, { useContext } from 'react';
import { InputProps } from 'atomic/form/input/input.interface';
import Icon from 'atomic/icon';
import classNames from 'classnames';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './input.scss';

let id = 0;

const Input: React.FC<InputProps> = React.forwardRef(({
    type = 'text',
    value,
    name,
    disabled,
    label,
    small = false,
    error,
    onChange,
    onBlur,
    icon,
    autoComplete = 'on',
    onKeyPress,
    min,
    max
}: InputProps, ref: React.Ref<HTMLInputElement>) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    if (api.getDevice() === 'mobile') {
        small = false;
    }

    const idx = id++;

    return (
        <div className="form-input">
            <input
                name={name}
                min={min || void 0}
                max={max || void 0}
                value={value}
                ref={ref}
                onChange={onChange}
                onKeyPress={onKeyPress}
                onBlur={onBlur}
                className={classNames(
                    {
                        ['input']: true,
                        ['input--small']: !!small,
                        ['input--disabled']: !!disabled,
                        ['input--error']: !!error,
                        ['input--icon']: !!icon
                    }
                )}
                type={type}
                id={idx.toString()}
                disabled={disabled}
                placeholder="&nbsp;"
                autoComplete={autoComplete}
                aria-label={name}
            />
            <label
                className={classNames(
                    {
                        ['input-label']: true,
                        ['input-label--small']: !!small,
                        ['input-label--error']: !!error
                    }
                )}
                data-label={label}
            />
            {error && (
                <span className="input-error-message">
                    {error.message}
                </span>
            )}
            {icon && (
                <Icon
                    className={classNames(
                        {
                            ['input-icon']: true,
                            ['input-icon--small']: !!small
                        }
                    )}
                    name={icon.name}
                    title={icon.title}
                    size={18}
                />
            )}
        </div>
    );
});

Input.displayName = 'Input';

export default Input;
